import React from "react";

import { IProduct } from "../../../models/catalogue";
import { isoProductCategoryID } from "../../../models/nominals";
import { strToBool } from "../../../utils/format";
import { type INavProps, ProductGrid, narrowNavProps } from "../ProductGrid";
import { buildGridFilterConfigs } from "../filters";
import { GridSortPlacement, GridVariant } from "../models";
import { buildGridSorterConfigs } from "../sorters";
import { BuildGridTile } from "../tiles";

type IProps = INavProps & {
    gridVariant: GridVariant;
    productCategoryID: string;
    filters: string;
    sorters: string;
    hideSort: string;
    /** See `GridSortPlacement`. */
    sortPlacement?: GridSortPlacement;
    disableHoverOverlay: string;
    buildExternalCallout?: (rootProduct: IProduct) => React.ReactNode;
    /**
     * See `BuildGridTile`. When set, `disableHoverOverlay` and
     * `buildExternalCallout` configure a `ProductCard` the tile renders only
     * for the products it hands back through `renderDefault` -- not dead,
     * just conditional.
     */
    buildTile?: BuildGridTile;
};

export const StreamFieldProductGrid = (props: IProps): React.JSX.Element => {
    return (
        <ProductGrid
            gridVariant={props.gridVariant}
            productCategoryID={isoProductCategoryID.wrap(
                parseInt(props.productCategoryID, 10),
            )}
            filters={buildGridFilterConfigs(props.filters)}
            sorters={buildGridSorterConfigs(props.sorters)}
            hideSort={strToBool(props.hideSort)}
            sortPlacement={props.sortPlacement}
            disableHoverOverlay={strToBool(props.disableHoverOverlay)}
            // Forwarded as a pair -- see `narrowNavProps`.
            {...narrowNavProps(props)}
            buildExternalCallout={props.buildExternalCallout}
            buildTile={props.buildTile}
        />
    );
};
